import {useEffect} from "react";
import {useLocation} from "react-router-dom";

import {initGoogleAnalytics, trackPageView} from "./googleAnalytics";

const GoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        initGoogleAnalytics();
    }, []);

    useEffect(() => {
        trackPageView(`${location.pathname}${location.search}`);
    }, [location]);

    return null;
};

export default GoogleAnalytics;
